/**
 * @documental
 * @export Action
 * @name
 * Table.Actions.Action
 */
import { FC, ReactNode } from "react";

import { BaseProps } from "../../../BaseProps";
import { DataId } from "../../DataId";
import { IconColor, IconName } from "../../Icon";
import { ActionClickHandler } from "./ActionsInternal/ActionClickHandler";
import { ActionDisabledCallback } from "./ActionsInternal/ActionDisabledCallback";
import { ActionVisibilityCallback } from "./ActionsInternal/ActionVisibilityCallback";
import { AccessibilityProps } from "../../../AccessibilityProps";

/**
 * The `Action` component properties.
 */
export interface ActionProps extends BaseProps, Pick<AccessibilityProps, "aria-label"> {
  /**
   * The action icon.
   */
  readonly icon: IconName | ((id: DataId) => IconName);

  /**
   * The icon color. If not specified defaults to `"body"`.
   */
  readonly color?: IconColor;

  /**
   * The action tooltip.
   */
  readonly tooltip: ReactNode | ((id: DataId) => ReactNode);

  /**
   * Function which called indicates whether the action is disabled.
   */
  readonly disabled?: ActionDisabledCallback;

  /**
   * Function which called indicates whether the action is visible.
   */
  readonly visible?: ActionVisibilityCallback;

  /**
   * Called when the action is clicked.
   */
  readonly onClick?: ActionClickHandler;
}

/**
 * Represents a single action which can be placed within the `Actions` column component.
 */
export const Action: FC<ActionProps> = () => {
  return null;
};
